import { useCallback } from 'react';

import { formatAbsoluteDateTime } from '@/shared/utils/format-relative-time';

/**
 * Returns a formatter for notification timestamps (PRD 08 §4.2).
 * Absolute time only — `YYYY.MM.DD HH:MM`. PRD §4.2: 절대시각, 상대시간 미사용
 * (no relative "N일 전" text, in the list or the GNB dropdown).
 */
export function useNotificationTime() {
  return useCallback((iso: string): string => formatAbsoluteDateTime(iso), []);
}
